const usdFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function formatDollars(amount: number): string {
  return usdFormatter.format(amount);
}

export function formatDollarsFromCents(cents: number | null | undefined): string {
  if (cents == null || !Number.isFinite(cents)) return '$0.00';
  return usdFormatter.format(cents / 100);
}

export function formatDollarsFromCentsOrDash(cents: number | null | undefined): string {
  if (cents == null || !Number.isFinite(cents)) return '—';
  return usdFormatter.format(cents / 100);
}

export function formatDateTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '—';
  const datePart = date.toLocaleDateString();
  const timePart = date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  return `${datePart} ${timePart}`;
}

export function humanizeIndustry(value: string | null | undefined): string | null {
  if (!value) return null;
  return value
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatAnnualRevenue(value: string | number | null | undefined): string | null {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number.parseFloat(value);
  return Number.isNaN(n) ? String(value) : formatDollars(n);
}

export function extractPrice(pricing: unknown): number {
  if (pricing && typeof pricing === 'object' && 'price' in (pricing as Record<string, unknown>)) {
    return Number((pricing as Record<string, number>).price) / 100;
  }
  return 0;
}

export function extractPeriodUnit(billingPeriods: unknown): string | null {
  if (Array.isArray(billingPeriods)) {
    for (const period of billingPeriods) {
      if (period && typeof period === 'object' && 'periodUnit' in (period as Record<string, unknown>)) {
        const pu = (period as Record<string, unknown>).periodUnit;
        return pu == null ? null : String(pu);
      }
    }
  }
  return null;
}

export function formatPercent(value: number): string {
  return `${Math.round(value * 100) / 100}%`;
}

export function formatCurrencyAmount(amount: number, currencyCode: string | null | undefined): string {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode || 'USD',
    }).format(amount);
  } catch {
    return usdFormatter.format(amount);
  }
}

export function compactDollars(dollars: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(dollars);
}
